<template>
  <p>Generate Document</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>